import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_ROLE_ENDPOINT } from '@/services/org-admin';
import type { UpdateOrgRoleInput, OrgRoleResponse } from '@/services/org-admin';

export function useUpdateOrgRole() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: async ({ roleId, input }: { roleId: string; input: UpdateOrgRoleInput }) => {
      const { data } = await axiosInstance.patch<OrgRoleResponse>(ORG_ROLE_ENDPOINT(orgId!, roleId), input);
      return data.role;
    },
    onSuccess: () => {
      // Role name changes propagate into members/invitations responses (role_name), refresh both
      void queryClient.invalidateQueries({ queryKey: ['org-roles', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['org-members', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['org-invitations', orgId] });
    },
    // Caller already shows its own success/error toast — suppress the global one.
    meta: { silent: true },
  });
}
